import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './theme/theme.ts';

// Do not even import ordinary account/analytics modules on a marketing entry.
const Entry = React.lazy(async () => {
  if (window.location.pathname.startsWith('/marketing/')) {
    const { MarketingPage } = await import('./components/pages/precheck/MarketingPage.tsx');
    return { default: MarketingPage };
  }
  const { initMixpanel } = await import('./utils/mixpanel.ts');
  initMixpanel();
  return import('./App.tsx');
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <ChakraProvider theme={theme}>
    <React.Suspense fallback={null}><Entry /></React.Suspense>
  </ChakraProvider>,
);
